import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import PaperDraggable from "../../../../../../../../components/PaperDraggable";
import SelectPublico from "../../../../../../../../components/SelectsSimpleApiQuery/SelectPublico";
import {
  formatarCPFCNPJ,
  permitirApenasNumeros,
} from "../../../../../../../../helpers/masks";
import SelectBancos from "../../../../../../../../components/SelectsSimpleApiQuery/SelectBancos";

export default function DialogEditCheque({
  open,
  handleClose,
}: DialogEditChequeProps) {
  const { handleSubmit, control, getValues, watch } = useFormContext();

  const isSubmitting = watch("loading");
  const onSubmit = getValues("onSubmit");

  const handleAtualizar = (data: any) => {
    onSubmit(data);
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperDraggable}
      aria-labelledby="draggable-dialog-title"
      fullWidth
      maxWidth="md"
      scroll="body"
    >
      <DialogTitle
        style={{ cursor: "move", paddingBottom: 0 }}
        id="draggable-dialog-title"
      >
        Editar dados do cheque
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={2} pt={3}>
          <Grid size={{ xs: 6 }}>
            <Controller
              name="detalhe.dadosCheque.publico"
              control={control}
              rules={{ required: "Campo obrigatório" }}
              render={({ field, fieldState: { error, invalid } }) => {
                return (
                  <SelectPublico
                    {...field}
                    error={invalid}
                    required
                    errorMessage={error?.message}
                    value={field.value}
                    onChange={(valor) => {
                      field.onChange(valor);
                    }}
                    extraParams={{ retornar_cheque_contas: true }}
                  />
                );
              }}
            />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <Controller
              name="detalhe.dadosCheque.documento"
              control={control}
              render={({ field, fieldState: { error, invalid } }) => (
                <TextField
                  {...field}
                  required
                  error={invalid}
                  fullWidth
                  label="CPF/CNPJ"
                  value={field.value}
                  slotProps={{ htmlInput: { maxLength: 16 } }}
                  onChange={(valor) => {
                    const newValue = formatarCPFCNPJ(valor.target.value);
                    field.onChange(newValue);
                  }}
                  helperText={invalid ? error?.message : ""}
                  disabled
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <Controller
              name="detalhe.dadosCheque.banco"
              control={control}
              render={({ field, fieldState: { error, invalid } }) => {
                return (
                  <SelectBancos
                    {...field}
                    error={invalid}
                    required
                    errorMessage={error?.message}
                    value={field.value}
                    onChange={(valor) => {
                      field.onChange(valor);
                    }}
                    disabled
                  />
                );
              }}
            />
          </Grid>
          <Grid size={{ xs: 3 }}>
            <Controller
              name="detalhe.dadosCheque.agencia"
              // rules={{ required: "Campo obrigatório" }}
              control={control}
              render={({ field, fieldState: { error, invalid } }) => (
                <TextField
                  {...field}
                  required
                  error={invalid}
                  fullWidth
                  label="Agência"
                  slotProps={{ htmlInput: { maxLength: 5 } }}
                  value={field.value}
                  onChange={(valor) => {
                    const newValue = permitirApenasNumeros(valor.target.value);
                    field.onChange(newValue);
                  }}
                  helperText={invalid ? error?.message : ""}
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 3 }}>
            <Controller
              name="detalhe.dadosCheque.agencia_digito"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Agência dígito"
                  value={field.value}
                  onChange={(valor) => {
                    const newValue = (valor.target.value);
                    field.onChange(newValue);
                  }}
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 3 }}>
            <Controller
              name="detalhe.dadosCheque.conta"
              rules={{ required: "Campo obrigatório" }}
              control={control}
              render={({ field, fieldState: { error, invalid } }) => (
                <TextField
                  {...field}
                  required
                  error={invalid}
                  fullWidth
                  label="Conta"
                  slotProps={{ htmlInput: { maxLength: 12 } }}
                  value={field.value}
                  onChange={(valor) => {
                    const newValue = permitirApenasNumeros(valor.target.value);
                    field.onChange(newValue);
                  }}
                  helperText={invalid ? error?.message : ""}
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 3 }}>
            <Controller
              name="detalhe.dadosCheque.conta_digito"
              rules={{ required: "Campo obrigatório" }}
              control={control}
              render={({ field, fieldState: { error, invalid } }) => (
                <TextField
                  {...field}
                  required
                  error={invalid}
                  fullWidth
                  label="Conta dígito"
                  value={field.value}
                  onChange={(valor) => {
                    const newValue = (valor.target.value);
                    field.onChange(newValue);
                  }}
                  helperText={invalid ? error?.message : ""}
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 3 }}>
            <Controller
              name="detalhe.dadosCheque.numero_cheque"
              control={control}
              render={({ field, fieldState: { error, invalid } }) => (
                <TextField
                  {...field}
                  required
                  error={invalid}
                  fullWidth
                  label="Número Cheque"
                  slotProps={{ htmlInput: { maxLength: 10 } }}
                  value={field.value}
                  onChange={(valor) => {
                    const newValue = permitirApenasNumeros(valor.target.value);
                    field.onChange(newValue);
                  }}
                  helperText={invalid ? error?.message : ""}
                  disabled
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 3 }}>
            <Controller
              name="detalhe.dadosCheque.sequencia_cheque"
              control={control}
              render={({ field, fieldState: { error, invalid } }) => (
                <TextField
                  {...field}
                  required
                  error={invalid}
                  fullWidth
                  label="Sequência cheque"
                  slotProps={{ htmlInput: { maxLength: 3 } }}
                  value={field.value}
                  onChange={(valor) => {
                    const newValue = permitirApenasNumeros(valor.target.value);
                    field.onChange(newValue);
                  }}
                  helperText={invalid ? error?.message : ""}
                  disabled
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button
          disabled={isSubmitting}
          variant="contained"
          type="submit"
          onClick={handleSubmit(handleAtualizar)}
        >
          {isSubmitting && (
            <CircularProgress size={20} sx={{ marginRight: 1 }} />
          )}
          Editar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

interface DialogEditChequeProps {
  open: boolean;
  handleClose: () => void;
}
